import React from 'react';
import pt from 'prop-types';

import { getCanvasElement } from 'components/storefront/editor/utils/easyblocks';
import {
  MESSAGE_EVENTS,
  postStorefrontOverlayClosed,
} from 'components/storefront/editor/utils/post-message';

import AddPageItemOverlay from './add-page-item';
import PageItemEllipsisOverlay from './page-item-ellipsis';
import PageEllipsisOverlay from './page-ellipsis';

import './overlay.scss';

export default class StorefrontEditorOverlay extends React.PureComponent {
  static propTypes = {
    type: pt.string,
  };

  state = {
    type: null,
    data: null,
    canvas: false,
  };

  componentDidMount() {
    window.addEventListener('message', this.eventListener);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.eventListener);
  }

  /** @param {MessageEvent} event */
  eventListener = (event) => {
    const { type, payload, canvas } = event.data;

    switch (type) {
      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.PAGE_ELLIPSIS:
      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.PAGE_ITEM_ELLIPSIS:
      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.ADD_PAGE_ITEM:
        return this.setState({
          type,
          data: this.adjustDomRect(payload, canvas),
          canvas,
        });

      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.CLOSED:
        return this.setState({ type: null, data: null, canvas: false });

      default:
        return;
    }
  };

  adjustDomRect(payload, canvas) {
    const domRect = payload?.domRect;

    if (!canvas || !domRect) {
      return payload;
    }

    const canvasElement = getCanvasElement();

    if (!canvasElement) {
      return payload;
    }

    const canvasRect = canvasElement.getBoundingClientRect();

    // Adjust the overlay position when it is called from the canvas iframe
    return {
      ...payload,
      domRect: {
        ...domRect,
        top: domRect.top + canvasRect.top,
        left: domRect.left + canvasRect.left,
        right: domRect.right + canvasRect.left,
        bottom: domRect.bottom + canvasRect.top,
      },
    };
  }

  getOverlayComponent() {
    switch (this.state.type) {
      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.ADD_PAGE_ITEM:
        return AddPageItemOverlay;

      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.PAGE_ITEM_ELLIPSIS:
        return PageItemEllipsisOverlay;

      case MESSAGE_EVENTS.STOREFRONT_EDITOR.OVERLAY.PAGE_ELLIPSIS:
        return PageEllipsisOverlay;

      default:
        return null;
    }
  }

  closeCanvasOverlay() {
    const { canvas } = this.state;

    if (!canvas) {
      return;
    }

    const canvasElement = getCanvasElement();

    if (canvasElement) {
      return postStorefrontOverlayClosed(canvasElement.contentWindow);
    }
  }

  onClose = () => {
    this.closeCanvasOverlay();
    postStorefrontOverlayClosed();
  };

  render() {
    const OverlayComponent = this.getOverlayComponent();

    if (!OverlayComponent) {
      return null;
    }

    const { data } = this.state;

    return (
      <OverlayComponent {...this.props} data={data} onClose={this.onClose} />
    );
  }
}
